import { render, staticRenderFns } from "./Page404.vue?vue&type=template&id=6f22e4a5&scoped=true&lang=pug&"
import script from "./Page404.vue?vue&type=script&lang=js&"
export * from "./Page404.vue?vue&type=script&lang=js&"
import style0 from "./Page404.vue?vue&type=style&index=0&id=6f22e4a5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f22e4a5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jackie/sites/cardinalco/ylang-23/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f22e4a5')) {
      api.createRecord('6f22e4a5', component.options)
    } else {
      api.reload('6f22e4a5', component.options)
    }
    module.hot.accept("./Page404.vue?vue&type=template&id=6f22e4a5&scoped=true&lang=pug&", function () {
      api.rerender('6f22e4a5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/pages/Page404.vue"
export default component.exports